import React from "react";

interface PowerBIProps {
    embedUrl: string;
}

export const PowerBIFrame: React.FC<PowerBIProps> = ({ embedUrl }) => {
    return (
        <div style={{ width: "100%", height: "80vh" }}>
            <iframe
                title="Power BI Dashboard"
                width="100%"
                height="100%"
                src={embedUrl}
                style={{ border: "none" }} 
                allowFullScreen
            ></iframe>
        </div>
    );
};


